import { applyFilters, doRequest } from "./helpers";

export default class EmailFooterService {
  static async getCustomFields() {
    return doRequest("GET", "/email/assets/footers/custom_fields");
  }

  static async getEmailFooters(filters = null) {
    let path = `/email/assets/footers/`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getEmailFootersForFilters() {
    return doRequest("GET", "/email/assets/footers/for_filters");
  }

  static async getEmailFooter(id, filters = null) {
    let path = `/email/assets/footers/${id}`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async editEmailFooter(id, name, html, tags) {
    return doRequest("PUT", `/email/assets/footers/${id}`, {
      data: {
        name,
        html,
        tags,
      },
    });
  }
  static async deleteEmailFooter(id) {
    return doRequest("DELETE", `/email/assets/footers/${id}`);
  }

  static async createEmailFooter(name, html, tags) {
    return doRequest("POST", "/email/assets/footers/", {
      data: {
        name,
        html,
        tags,
      },
    });
  }
}
